// react
import { useState } from "react";
// axios
import axios from "../../../axios/axios";
// components
import Ripple from "../../ui/spinners/ripple/Ripple";
// icons
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
// helpers
import { parseJWT } from "../../../helpers/auth";
// react redux
import { useDispatch } from "react-redux";
// action creators
import { login } from "../../../redux/auth";
// react router
import { useNavigate } from "react-router-dom";

const LoginForm = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    error: null,
  });

  const [passwordType, setPasswordType] = useState("password");

  // handle show/hide password
  const togglePasswordHandler = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  // handle input change
  const inputChangedHandler = (event) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [event.target.name]: event.target.value,
    }));
  };

  // focus input handler
  const inputFocusHandler = (event) => {
    event.target.readOnly = false;
  };

  // handle login
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loginUserHandler = (event) => {
    event.preventDefault();
    setSubmitButtonDisabled(true);

    axios({
      method: "POST",
      url: "/user/websiteLogin",
      data: { username: formData.username, password: formData.password },
    })
      .then((res) => res.data)
      .then((data) => {
        setFormData((prevFormData) => ({ ...prevFormData, error: "" }));
        setSubmitButtonDisabled(false);
        window.localStorage.setItem("apiToken", data.jwtToken);
        const user = parseJWT(data.jwtToken);
        dispatch(login(user));
        navigate("/");
      })
      .catch((err) => {
        setSubmitButtonDisabled(false);
        if (err?.response?.status === 401) {
          setFormData((prevData) => ({
            ...prevData,
            error: "بيانات الدخول غير صحيحة",
          }));
        }
      });
  };

  return (
    <form method="POST" className="space-y-4 w-full" autoComplete="off">
      <div>
        <div className="my-1">
          <label htmlFor="username" className="font-semibold text-base">
            اسم المستخدم
          </label>
          <input
            id="username"
            className="p-2 border border-#DFDFDF rounded w-full text-right"
            type="text"
            value={formData.username}
            readOnly
            name="username"
            onChange={inputChangedHandler}
            onFocus={inputFocusHandler}
          />
        </div>

        <div>
          <label htmlFor="password" className="font-semibold text-base">
            كلمة السر
          </label>
          <div className="relative">
            <input
              id="password"
              className="p-2 border border-#DFDFDF rounded w-full text-right"
              type={passwordType}
              value={formData.password}
              readOnly
              name="password"
              onChange={inputChangedHandler}
              onFocus={inputFocusHandler}
            />
            {passwordType === "password" ? (
              <AiOutlineEyeInvisible
                size={20}
                className="absolute left-2 top-1/2 -translate-y-1/2 cursor-pointer"
                onClick={togglePasswordHandler}
              />
            ) : (
              <AiOutlineEye
                size={20}
                className="absolute left-2 top-1/2 -translate-y-1/2 cursor-pointer"
                onClick={togglePasswordHandler}
              />
            )}
          </div>
        </div>
      </div>

      <button
        onClick={loginUserHandler}
        disabled={submitButtonDisabled}
        className="w-full flex justify-center items-center bg-dark-blue text-white text-center p-4 rounded-lg disabled:text-slate-800 disabled:bg-slate-200 disabled:cursor-not-allowed"
      >
        {submitButtonDisabled ? (
          <Ripple className="border-dark-blue" />
        ) : (
          "تسجبل الدخول"
        )}
      </button>

      {formData.error && (
        <p className="text-center uppercase text-red-600 font-semibold text-sm">
          {formData.error}
        </p>
      )}
    </form>
  );
};

export default LoginForm;
